import { forwardRef, type Ref, type SVGProps } from "react";
const IconExternalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 29 2h-8a1 1 0 1 0 0 2h5.6L12.29 18.3a1 1 0 0 0 0 1.41A1 1 0 0 0 13 20a1 1 0 0 0 .7-.29L28 5.4V11a1 1 0 1 0 2 0V3a1 1 0 0 0-.08-.38" />
    <path d="M27 19a1 1 0 0 0-1 1v8H4V6h9a1 1 0 0 0 0-2H4a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2v-8a1 1 0 0 0-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconExternalOutlineSVG);
ForwardRef.displayName = "IconExternalOutline";
export { ForwardRef as IconExternalOutline };
